import { useEffect, useState } from "react";
import { Col, Form, Select, message, Button } from "antd"; // Import Button for cleaner upload UI
import { LoadingOutlined, UploadOutlined } from "@ant-design/icons";
import {
  GET_BUYER_ENDPOINT,
  GET_BUYING_OFFICE_ENDPOINT,
  SALES_CONTRACT_LIST,
  STYLE_MERCHANDISING_LIST,
  UPLOAD_FOC_BOM,
} from "../../../apiServices/API_ENDPOINTS";
import { getData } from "../../../apiServices/common";

const BOMFilterFields = () => {
  const [buyingOffice, setBuyingOffice] = useState([]);
  const [salesContractList, setSalesContractList] = useState([]);
  const [buyerList, setBuyerList] = useState([]);
  const [styleList, setStyleList] = useState([]);
  const [loading, setLoading] = useState(false);

  const { Option } = Select;

  useEffect(() => {
    getBuyingOfficeList();
    getSalesContractList();
    getBuyerList();
    getStyleList();
  }, []);

  // ✅ API Functions (Simplified for brevity - no changes needed here)
  const getBuyingOfficeList = async (filterValues = {}) => {
    const query = `${GET_BUYING_OFFICE_ENDPOINT}`;
    const bodyData = { per_page: 10, name: filterValues?.name || "" };
    const res = await getData(query, false, bodyData);
    if (res) setBuyingOffice(res?.data?.data?.data || []);
  };

  const getSalesContractList = async (filterValues = {}) => {
    const query = `${SALES_CONTRACT_LIST}`;
    const bodyData = { per_page: 10, reference_no: filterValues?.reference_no || "" };
    const res = await getData(query, false, bodyData);
    if (res) setSalesContractList(res?.data?.data?.data || []);
  };

  const getBuyerList = async (filterValues = {}) => {
    const query = `${GET_BUYER_ENDPOINT}`;
    const bodyData = { per_page: 10, name: filterValues?.name || "" };
    const res = await getData(query, false, bodyData);
    if (res) setBuyerList(res?.data?.data?.data || []);
  };

  const getStyleList = async (style_no = "") => {
    const bodyData = { style_no };
    const res = await getData(STYLE_MERCHANDISING_LIST, false, bodyData);
    if (res) setStyleList(res?.data?.data?.data || []);
  };

  // ✅ File Upload Function (No changes needed here)
  // const uploadFile = async (file) => {
  //   if (!file) return;
  //   setLoading(true);

  //   const URL = process.env.REACT_APP_BASE_URL + UPLOAD_FOC_BOM;
  //   const token = localStorage.getItem("token");
  //   const formData = new FormData();
  //   formData.append("csv_file", file);

  //   try {
  //     const response = await fetch(URL, {
  //       method: "POST",
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //       body: formData,
  //     });

  //     const contentType = response.headers.get("content-type");
  //     if (
  //       contentType &&
  //       (contentType.includes("application/vnd.ms-excel") ||
  //         contentType.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"))
  //     ) {
  //       // ... file download logic (omitted for brevity)
  //       const blob = await response.blob();
  //       const url = window.URL.createObjectURL(blob);
  //       const a = document.createElement("a");
  //       a.href = url;
  //       const filename =
  //         response.headers.get("content-disposition")?.split("filename=")[1] ||
  //         "download.xlsx";
  //       a.download = filename.replace(/"/g, ''); // Clean up quotes
  //       document.body.appendChild(a);
  //       a.click();
  //       document.body.removeChild(a);
  //       window.URL.revokeObjectURL(url);
  //       message.success("File downloaded successfully");
  //     } else {
  //       const result = await response.json();
  //       if (response.ok && result.code === 200) {
  //         message.success("File uploaded successfully");
  //       } else {
  //         message.error(result.message || "Error uploading file!");
  //       }
  //     }
  //   } catch (error) {
  //     message.error(error.message || "Upload failed!");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // --- FIX APPLIED HERE ---
  return (
    <>
      {/* Buying Office */}
      <Col span={4}>
        <Form.Item label="Buying Office" name="buying_office_id">
          <Select
            showSearch
            placeholder="Select a Buying Office"
            optionFilterProp="children"
            size="small"
            onSearch={(value) => getBuyingOfficeList({ name: value })}
            allowClear
            onClear={() => getBuyingOfficeList()}
          >
            {buyingOffice.map((office) => (
              <Option key={office.id} value={office.id}>
                {office.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>

      {/* Sales Contract */}
      <Col span={4}>
        <Form.Item label="Sales Contract No" name="sales_contract_id">
          <Select
            showSearch
            placeholder="Select a Sales Contract No"
            optionFilterProp="children"
            size="small"
            onSearch={(value) => getSalesContractList({ reference_no: value })}
            allowClear
            onClear={() => getSalesContractList()}
          >
            {salesContractList.map((contract) => (
              <Option key={contract.id} value={contract.id}>
                {contract.reference_no}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>

      {/* Buyer */}
      <Col span={4}>
        <Form.Item label="Buyer" name="buyer_id">
          <Select
            showSearch
            placeholder="Select a Buyer"
            optionFilterProp="children"
            size="small"
            onSearch={(value) => getBuyerList({ name: value })}
            allowClear
            onClear={() => getBuyerList()}
          >
            {buyerList.map((buyer) => (
              <Option key={buyer.id} value={buyer.id}>
                {buyer.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>

      {/* Style */}
      <Col span={4}>
        <Form.Item label="Style No." name="style_id">
          <Select
            showSearch
            placeholder="Select a Style No."
            optionFilterProp="children"
            onSearch={(value) => getStyleList(value)}
            size="small"
            allowClear
            onClear={() => getStyleList()}
          >
            {styleList.map((style) => (
              <Option key={style.id} value={style.id}>
                {style.style_no}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>

      {/* File Upload (FIXED) */}
      {/* <Col span={4}>
        <Form.Item colon={false} style={{ marginTop: '23px' }}>
          <input
            type="file"
            id="file-input-bom" // Changed ID to avoid potential conflicts
            hidden
            accept=".csv"
            onChange={(e) => uploadFile(e.target.files[0])}
            onClick={(e) => { e.target.value = null }} 
          />
          <Button
            type="primary"
            size="small"
            loading={loading}
            icon={loading ? <LoadingOutlined /> : <UploadOutlined />}
            onClick={() => document.getElementById("file-input-bom").click()}
          >
            Upload BOM
          </Button>
        </Form.Item>
      </Col> */}
    </>
  );
};

export default BOMFilterFields;